<template>
  <section id="introduce">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
           <v-col  class="text-center">
              <h2 class="font-weight-light:999  display-1 padding-top-80">公司介绍</h2>
              <h1 class="font-weight-light:999  display-1 custom-text-color" >Introduce</h1>
            </v-col>
              <v-row>
                <!-- <Carousel/> -->
                 <introduceList/>
              </v-row>
            </v-col>
          </v-row>
            <!-- <v-col cols="12" md="5" class="d-none d-md-flex">
              <v-img
                src="@/assets/img/ill1.svg"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col> -->
       
    </v-container>
  </section>
</template>

<script scope>
// import  Carousel  from './Carousel.vue'
import introduceList from './introduceList.vue';
export default {
 name: "introduce",
  components: {
    // Carousel,
    introduceList
  }
}
</script>


<style scoped>
#about {
  background-color: #f4f7f5;
}
.text-center{
  padding-top: 50px;
}

</style>
